


import OrkPasswordStrengthMeter from "@/components/Ork/OrkPasswordStrengthMeter.vue";

export default {
  name: "OrkPasswordJudge",
  components: { OrkPasswordStrengthMeter },
  emits: ['password-validity'],
  props: {
    password: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default(): any {
        return {
          minimumPasswordLength: 12,
          maximumPasswordLength: 75,
          minimumStrengthScore: 3,
          needsUppercaseCharacter: true,
          needsLowercaseCharacter: true,
          needsSpecialCharacter: true,
          needsNumberCharacter: true,
        };
      }
    }
  },
  data(): any {
    return {
      passwordScore: 0,
    }
  },
  computed: {
    isScoreCapped(): boolean {
      return !this.areCriteriaChecked;
    },
    passwordContainsLowercaseCharacter(): boolean {
      return this.password?.match(/[a-z]/);
    },
    passwordContainsUppercaseCharacter(): boolean {
      return this.password?.match(/[A-Z]/);
    },
    passwordContainsNumberCharacter(): boolean {
      return this.password?.match(/[0-9]/);
    },
    passwordContainsSpecialCharacter(): boolean {
      return this.password?.match(/[@$!%*?&).]/) && !this.password.match(/[^a-zA-Z0-9@$!%*?&).]/);
    },
    passwordIsBetweenMinAndMaxLength(): boolean {
      if (!this.password) {
        return false;
      }

      const length = this.password.length;

      return this.options.minimumPasswordLength <= length && length <= this.options.maximumPasswordLength;
    },
    passwordScoreIsSufficient(): boolean {
      return this.passwordScore >= this.options.minimumStrengthScore;
    },
    areCriteriaChecked(): boolean {
      return this.passwordContainsLowercaseCharacter
          && this.passwordContainsUppercaseCharacter
          && this.passwordContainsNumberCharacter
          && this.passwordContainsSpecialCharacter
          && this.passwordContainsNumberCharacter
          && this.passwordIsBetweenMinAndMaxLength;
    },
    isPasswordValid(): boolean {
      return this.areCriteriaChecked && this.passwordScoreIsSufficient;
    }
  },
  watch: {
    isPasswordValid(newVal: boolean): void {
      this.$emit('password-validity', newVal);
    }
  },
  methods: {
    onScoreChange(score: number | null): void {
      this.passwordScore = score;
    }
  },
};
